import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-reveal';
import {
  HorizontalLayout,
  Padding,
  Section,
} from '@/features/new-landing-page/components/section';
import { StrapiTextual } from '@/features/strapi/components/textual';
import { DisruptContent } from '@/features/new-landing-page/pages/homepage-content';
import { VSpace } from '@/components/spacing';
import { breakpoints } from '@/components/responsive';
import { StrapiImageTextual } from '@/features/strapi/components/image-textual';

export function DisruptSection({ ctaHref }: { ctaHref?: string }) {
  return (
    <CustomSection>
      <VSpace value={7} mobileValue={3} />
      <Padding padding="0 8rem">
        <StrapiTextual {...DisruptContent.title} />
      </Padding>
      <VSpace value={6} />
      <Fade bottom>
        <HorizontalLayout gridColumns="2fr 1fr 1fr 2fr" mobileGridColumns="1fr">
          <div />
          <StrapiTextual
            className="dis-btn-primary"
            {...DisruptContent.getVisuallyButton}
            href={ctaHref || DisruptContent.getVisuallyButton.href}
          />
          <StrapiTextual
            className="dis-btn-secondary"
            {...DisruptContent.getExpertButton}
          />
          <div />
        </HorizontalLayout>
      </Fade>
      <VSpace value={5} />
      <Fade bottom>
        <HorizontalLayout
          mobileGridColumns="max-content max-content max-content"
          gap="2.4rem"
        >
          {DisruptContent.benefitUsps.map((usp) => (
            <StrapiImageTextual key={usp.text} textual={usp} />
          ))}
        </HorizontalLayout>
      </Fade>
      <VSpace value={11} mobileValue={5} />
    </CustomSection>
  );
}

const CustomSection = styled(Section)`
  && {
    background: #dc4949 !important;
    color: white;

    && > * {
      margin-bottom: 0;
    }

    .dis-btn-primary {
      padding: 1.5rem 5rem;
      font-size: 2.4rem;
      color: black;
      background: white;
      border-radius: 3rem;
      border: 2px solid white;

      ${breakpoints.down(`md`)} {
        padding: 1rem 4rem;
        margin-bottom: 2rem;
        font-size: 1.7rem;
      }
    }

    .dis-btn-secondary {
      padding: 1.5rem 5rem;
      font-size: 2.4rem;
      color: white;
      background: transparent;
      border: 2px solid white;
      border-radius: 3rem;

      ${breakpoints.down(`md`)} {
        padding: 1rem 4rem;
        font-size: 1.7rem;
      }
    }
  }
`;
